import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { css } from 'styled-components'

import { getAgreements } from '@/ports'
import { FetchResponse } from '@/ports/api'
import GeneralInformationLayout from '@/layouts/general-information'
import { Title } from '@/features/GeneralInformation/elements'
import Policy from '@/features/GeneralInformation/policy'
import Head from '@/components/head'

const custom = css`
  & * {
    font-size: 13px !important;
  }
  .Authorname {
    margin: 0 0 55px !important;
    * {
      font-style: normal !important;
    }
  }
`

type TermsBody = {
  terms_conditions: {
    txt_id: string
    version: string
    title: string
    content: string
    version_type: string
    grace_period_date: string
  }
}

type TermsProps = {
  terms: TermsBody['terms_conditions']['content']
}

const Terms = ({ terms }: TermsProps) => {
  const { t } = useTranslation()
  const metaTitle = t('terms:Terms and Conditions | liv.rent')

  return (
    <>
      <Head title={metaTitle} path="/terms" noDescription hideCustomerSupport />
      <Title>{t('terms:Terms')}</Title>
      <p>
        <strong>liv.rent Terms and Conditions</strong>
      </p>
      <Policy description={terms} customStyle={custom} />
    </>
  )
}

export const getStaticProps = async ({ locale }: { locale: string }) => {
  const terms = (await getAgreements({
    body: ['terms_conditions']
  })) as FetchResponse<TermsBody>

  if (!terms?.body?.terms_conditions?.content) throw new Error('No content')

  return {
    props: {
      terms: terms?.body?.terms_conditions?.content || null,
      ...(await serverSideTranslations(locale, ['translation', 'terms']))
    }
  }
}

Terms.Layout = GeneralInformationLayout

export default Terms
